import {Box, styled, Typography} from "@mui/material";
import { useTranslation } from 'react-i18next';
import useIsMobile from "../hooks/useIsMobile.hook";

function agentHas(keyword) {
  return navigator.userAgent.toLowerCase().search(keyword.toLowerCase()) > -1;
}

const isSafari = () => (!!window.ApplePaySetupFeature || !!window.safari) && agentHas("Safari") && !agentHas("Chrome") && !agentHas("CriOS");

const Image = styled('img')(() => ({
  position: 'absolute',
  width: '96%',
  top: '50%',
  transform: 'translateY(-50%)',
}));

const Photo = styled('img')(() => ({
  width: '100%',
  objectFit: 'cover',
}));

const Text = styled(Typography)(({ theme }) => ({
  position: 'absolute',
  left: 0,
  right: 0,
  padding: '0 24px',
  top: '10%',
  textAlign: 'center',
  fontFamily: '"M PLUS Rounded 1c", sans-serif',
  color: '#fff',
  [theme.breakpoints.up('xs')]: {
    display: 'none',
    '-webkit-text-stroke': '1px black',
  },
  [theme.breakpoints.up('sm')]: {
    top: '12%',
    fontSize: 36,
  },
  [theme.breakpoints.up('md')]: {
    top: '8%',
    fontSize: 48,
    '-webkit-text-stroke': '2px black',
  },
  [theme.breakpoints.up('lg')]: {
    top: '15%',
    fontSize: 61,
  },
}));

const MainSection = ({ scrollToSection }) => {
  const { t } = useTranslation();
  const isMobile = useIsMobile();

  return (
    <Box sx={{ p: 2, mt: 2 }} display="flex" flexDirection="column" alignItems="center">
      <Typography sx={{ pb: 3 }} fontWeight={600} variant={isMobile ? 'h5' : "h3"} textAlign="center">Wir wollen Menschen helfen, JESUS zu finden</Typography>
      <Box sx={{maxWidth: 1200, position: 'relative', width: '100%'}} display="flex" justifyContent="center">
        <Box sx={{ overflow: 'hidden', borderRadius: 2, maxHeight: 500 }} display="flex">
          <Photo src="/img/photo_5415900533182553120_y.jpg" alt="main_photo"/>
          <Box sx={{
            position: 'absolute',
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            background: 'rgba(0,0,0,0.45)',
            borderRadius: 2
          }} />
        </Box>
        {/*<Image src={isMobile ? 'img/losung-mobile.svg' : 'img/losung.svg'} />*/}
        <Text>{t('main.text')}</Text>
      </Box>
    </Box>
  );
};

export default MainSection;
